import { createFileRoute, redirect } from '@tanstack/react-router';
import { CataloguePage } from '../pages/catalogue/catalogue-page';
import { isAuthenticated, mustResetPassword } from '../auth/session';

/*
 * No search params. `?contestId=&reelNumber=` opened the catalogue in "reel
 * mode" — the full-page form that attached one outcome to one reel — which
 * CAE-1553's Add Outcomes modal replaces. The route is the browse screen now,
 * and a stale bookmark carrying those params simply lands on it.
 */
export const Route = createFileRoute('/catalogue')({
  beforeLoad: () => {
    if (!isAuthenticated()) {
      throw redirect({ to: '/login' });
    }
    if (mustResetPassword()) {
      throw redirect({ to: '/change-password' });
    }
  },
  component: CataloguePage,
});
